import { z } from 'zod';
export const SearchSchema = z.object({
  operationEventId: z.string().optional(),
  operationEventPatternId: z.string().optional()
});